// extracted by mini-css-extract-plugin
export var errorsContainer = "_s5-1";
export var link = "_s5-0";